//time-picker.component.ts

import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';

interface ITimeScheduler {
  [x: string]: any;
  hour: number[];
  minute: string[];
}
interface facilityOpHours {
  facilityHours: number;
  facilityMins: number;
}

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit, OnChanges {
  private _facilityOnChange: Subscription;
  private isToday: boolean;
  isClickedOnHours = false;
  isClickedOnMinutes = false;
  isClickedOnPeriods = false;

  @Output() currentTime = new EventEmitter();
  @Input()
  set today(val: any) {
    this.isToday = val;
    this.loadTimePickerforLargeDevices();
  }
  @Input()
  set disableController(val: string) {
    this.disableProperty(val);
  }

  @Input() fromPage?: string;
  @Input() is24Hours?: boolean;
  @Input() is24hrFormat?: boolean;
  // @Input() facTime: facilityOpHours;
  _facTime: facilityOpHours;
  @Input() set facTime(t: facilityOpHours) {
    this._facTime = t;
    // // console.log('TIME_', t);

    // if (!this.is24Hours && this.fromPage=='widget' && t.facilityHours == 23 && t.facilityMins == 59) {
    //   console.log('TIME_', t);
    //   // this.toggleSet24Hours();
    // }
  }

  isTodaysDate: boolean;
  selectedHourInt: number;
  timeininteger: string;
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  now = new Date();
  hourFormat = this.now.getHours() > 12 ? this.now.getHours() - 12 : this.now.getHours();
  currentlySelectedHour: string;
  currentlySelectedMinute: string;
  currentlySelectedMeridiem: string;
  time: string;
  timeScheduler: { hour: string[]; minute: string[] };
  hour: string[] = [];
  currentmeridiem: string;
  disableMobileInput: boolean = false;

  // disable enable ctrl
  disableHours: boolean = false;
  disableMinutes: boolean = false;
  disablePeriods: boolean = false;

  constructor(
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.facTime?.currentValue) {
      this._facTime = changes.facTime.currentValue
      this.operationTimeOnlyInit();
    }
    if (changes.disableController) {
      this.disableProperty(changes.disableController.currentValue);
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit(): void {
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
    this.setInitialTime();

    if (this.is24hrFormat && this.fromPage === 'widget') {
      this.operationTimeOnlyInit24hrFormat();
    } else if (this.fromPage === 'widget') {
      this.operationTimeOnlyInit();
    }

    if (this.rootScopeData.deviceType != 'phone') {
      this.loadTimePickerforLargeDevices();
    } else {
      this.setTimeForPhone();
    }
  }

  disableProperty(val: string): void {
    this.disableHours = val.includes('h') || this.currentFacility?.summary?.userRights.facility === 'V';
    this.disableMinutes = val.includes('m') || this.currentFacility?.summary?.userRights.facility === 'V';
    this.disablePeriods = val.includes('p') || this.currentFacility?.summary?.userRights.facility === 'V';
    this.disableMobileInput = val.includes('h') || val.includes('m') || val.includes('p');
    this.mobile24Hr();
  }

  operationTimeOnlyInit() {
    this.currentlySelectedMeridiem = this._facTime.facilityHours >= 12 ? 'PM' : 'AM';
    this.currentlySelectedHour = (
      '0' + (this._facTime.facilityHours > 12 ? this._facTime.facilityHours - 12 : this._facTime.facilityHours)
    ).slice(-2);
    this.currentlySelectedMinute = ('0' + this._facTime.facilityMins).slice(-2);

    if (this.currentlySelectedHour === '00') {
      this.currentlySelectedHour = '12';
    }

    // 24 hr selected
    if (this.is24Hours && this._facTime.facilityHours == 24) {
      this.currentlySelectedMeridiem = 'AM';
      if (this.rootScopeData.deviceType === 'phone') {
      } else {
        this.set24Hours();
      }
    }

    if (this.rootScopeData.deviceType === 'phone') {
      this.currentTime.emit(this.time);
    }
  }

  operationTimeOnlyInit24hrFormat() {
    this.currentlySelectedHour = ('0' + (this._facTime.facilityHours == 24 ? '0' : this._facTime.facilityHours)).slice(-2);
    this.currentlySelectedMinute = ('0' + this._facTime.facilityMins).slice(-2);

    // if (this.currentlySelectedHour === '24') {
    // }

    // 24 hr selected
    if (this.is24Hours && this._facTime.facilityHours == 24 && this.rootScopeData.deviceType != 'phone') {
      this.set24Hours();
    }

    if (this.rootScopeData.deviceType === 'phone') {
      this.currentTime.emit(this.time);
    }
  }

  setInitialTime() {
    if (this.fromPage === 'widget') {
    } else {
      this.currentlySelectedHour = ('0' + this.hourFormat).slice(-2);
      this.currentlySelectedMinute = ('0' + this.now.getMinutes()).slice(-2);
      this.currentlySelectedMeridiem = this.now.getHours() >= 12 ? 'PM' : 'AM';
      this.currentmeridiem = this.now.getHours() >= 12 ? 'PM' : 'AM';
    }

    // if (this.rootScopeData.deviceType === 'phone') {
    //   this.currentTime.emit(this.time);
    // }
  }

  getHour() {
    this.hour = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    if (this.is24hrFormat) {
      this.hour.unshift('00');
      this.hour.push('13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23');
    }

  }

  loadTimePickerforLargeDevices() {
    this.hour = [];
    this.setInitialTime();
    if (this.fromPage === 'widget') {
      this.getHour();
    } else {
      if (this.isToday === false) {
        this.getHour();
      } else {
        if (this.currentlySelectedMeridiem === 'PM') {
          if (this.hourFormat === 12) {
            this.getHour();
          } else {
            for (let j = this.hourFormat; j <= 11; j++) {
              this.hour.push(('0' + j).slice(-2));
            }
          }
        } else {
          this.getHour();
        }
      }
    }
    const minute = [];
    for (let i = 0; i <= 59; i++) {
      minute.push(('0' + i).slice(-2));
    }
    const hour = this.hour;
    this.timeScheduler = { hour, minute };
    this.selectedHourInt = parseInt(this.currentlySelectedHour);
  }

  setTimeForPhone() {
    // this.time = this.currentlySelectedHour + ':' + this.currentlySelectedMinute;
    this.mobile24Hr();
    this.currentTime.emit(this.time);
  }

  changeTime() {
    if (this.fromPage === 'widget') this.rootScopeData.isPageHasUnsavedChanges = true;
    this.currentTime.emit(this.time);
  }

  modifyTime(selectedTime: string, selectedValue: string) {
    if (this.fromPage === 'widget') this.rootScopeData.isPageHasUnsavedChanges = true;
    if (selectedValue === 'h') {
      this.currentlySelectedHour = selectedTime;
      this.selectedHourInt = parseInt(this.currentlySelectedHour);
      if (this.isToday === true && this.currentlySelectedMeridiem === 'AM') {
        if (this.selectedHourInt === 12) {
          this.currentlySelectedMeridiem = 'PM';
        } else {
          this.currentlySelectedMeridiem =
            this.selectedHourInt <= this.now.getHours() ? 'PM' : this.currentlySelectedMeridiem;
        }
      }
    } else if (selectedValue === 'm') {
      this.currentlySelectedMinute = selectedTime;
    } else {
      this.currentlySelectedMeridiem = selectedTime;
    }

    const selectedTimeSchedule = {
      hour: this.currentlySelectedHour,
      minute: this.currentlySelectedMinute,
      meridiem: this.currentlySelectedMeridiem,
    };
    let scheduledhour = parseInt(selectedTimeSchedule.hour);
    const scheduledminute = parseInt(selectedTimeSchedule.minute);
    if (this.currentlySelectedMeridiem === 'PM') {
      if (scheduledhour <= 12) {
        scheduledhour = scheduledhour + 12;
      }
    } else {
      if (scheduledhour === 12) {
        scheduledhour = 0;
      }
    }
    this.time = scheduledhour + ':' + scheduledminute;
    this.currentTime.emit(this.time);
  }

  set24Hours() {
    this.currentTime.emit('99:99');
    this.currentlySelectedHour = '24 Hours';
  }

  toggleSet24Hours() {
    this.disableMobileInput = !this.disableMobileInput;
    if (this.disableMobileInput) {
      this.currentTime.emit('99:99');
    } else {
      // this.setInitialTime();
      this.operationTimeOnlyInit();
      this.setTimeForPhone();
    }
  }

  mobile24Hr() {
    if (this.rootScopeData.deviceType === 'phone') {
      if (this.is24Hours) {
        this.time =
          ('0' + (this._facTime.facilityHours == 24 ? 0 : this._facTime.facilityHours)).slice(-2) +
          ':' +
          ('0' + this._facTime.facilityMins).slice(-2);
      } else {
        this.time =
          ('0' + (this._facTime.facilityHours == 24 ? 0 : this._facTime.facilityHours)).slice(-2) +
          ':' +
          ('0' + this._facTime.facilityMins).slice(-2);
      }
    }
  }

  ngOnDestroy() {
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }
}
